import React from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

function ClinicalProfile() {

    const { sample_id } = useParams();
    const sampleCode = useSelector((state) => state.sample.code);
    const buttonStyle = {
        margin: "10px",
        width: "400px",
        color: "black", height: "100px",
        backgroundColor: "#DFF5F1",
        border: "1px solid #4DB6AC"
    };
    return (
        <div className="text-center" style={{ position: "relative", minHeight: "70vh" }}>
            <h6 style={{ textAlign: "left" }}>Clinical Profile</h6>
            <div className="floating-label">
                {sampleCode}
            </div>
            <Link to={`/Update_Male_Details/${sample_id}`} className="text-decoration-none">
                <Button className="my-2 px-4" variant="warning" style={buttonStyle} size="sm">
                    Clinical Data
                </Button></Link>
            <br></br>
            <Link to={`/Follow-Up-Data/${sample_id}`} className="text-decoration-none">
                <Button className="my-2 px-4" variant="warning" style={buttonStyle} size="sm">
                    Follow up data
                </Button></Link>


            <style>{`
       

                
.floating-label {
  position: fixed;
  top: 50%;
  left: 1px;
  transform: translateY(-50%);

  background: linear-gradient(
    180deg,
    #ff5C4D   /* soft medical blue */ 
    
  ); 

  color: #3333BB;
   font-family: "Poppins", "Montserrat", "Segoe UI", sans-serif;
  padding: 14px 16px;
  border-radius: 10px;

  box-shadow:
    0 10px 25px rgba(30, 64, 175, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);

  z-index: 1000;

  writing-mode: vertical-rl;
  text-orientation: mixed;

  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;

  backdrop-filter: blur(4px);
}



      `}</style>
        </div>
    );
}

export default ClinicalProfile;
